/**
 * Analytics events object alternate keys dictionary
 */

export enum ViewArticleAltKeys {
    ARTICLE_ID = 'WCM ID',
    AUTHORS = 'Writer Byline', // to be removed
    CATEGORY = 'Article Category',
    ORIGINAL_ID = 'WP Post ID',
    TITLE = 'Article Name',
    SUB_SEC = 'Article Sub Section',
    WRITERS = 'Writer Byline'
}

export enum ScreenViewAltKeys {
    FORMAT = 'Markup Language',
    PAYWALL = 'Metered Content Type'
}

export enum VideoAltKeys {
    TITLE = 'Video Article Name',
    GLOBAL_ID = 'Global Post/Content ID (Video)',
    CATEGORY = 'Video Article Category'

}

export enum ShareArticleAltKeys {
    ARTICLE_ID = 'WCM ID',
    AUTHORS = 'Article Authors', // to be removed
    ORIGINAL_ID = 'WP Post ID',
    GLOBAL_ID = 'Global Post/Content ID',
    TITLE = 'Article Name ',
    SUB_SEC = 'Article Sub-Category/Section',
    CATEGORY = 'Article Category',
    WRITERS = 'Article Authors'
}

export enum WidgetAltKeys {
    AUTHORS = 'Author Text', // to be removed
    CATEGORY = 'Category Name',
    TITLE = 'Parent Story Title',
    ARTICLE_ID = 'Story ID',
    CUR_PAGE = 'Referring URL',
    WRITERS = 'Author Text'
}

export enum ButtonAltKeys {
    TITLE = 'Article Name'
}
